/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NotificationResponse
 */
export interface NotificationResponse {
    /**
     * 
     * @type {string}
     * @memberof NotificationResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationResponse
     */
    type: NotificationResponseTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof NotificationResponse
     */
    priority: NotificationResponsePriorityEnum;
    /**
     * 
     * @type {string}
     * @memberof NotificationResponse
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationResponse
     */
    body: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationResponse
     */
    icon?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationResponse
     */
    actionType: NotificationResponseActionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof NotificationResponse
     */
    actionUrl?: string;
    /**
     * 
     * @type {object}
     * @memberof NotificationResponse
     */
    actionData?: object;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationResponse
     */
    read: boolean;
    /**
     * 
     * @type {Date}
     * @memberof NotificationResponse
     */
    readAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof NotificationResponse
     */
    sourceType?: NotificationResponseSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof NotificationResponse
     */
    sourceId?: string;
    /**
     * 
     * @type {Date}
     * @memberof NotificationResponse
     */
    createdAt: Date;
}


/**
 * @export
 */
export const NotificationResponseTypeEnum = {
    match_ready: 'match_ready',
    check_in_reminder: 'check_in_reminder',
    friend_request: 'friend_request',
    team_invite: 'team_invite',
    competition_invite: 'competition_invite',
    competition_update: 'competition_update',
    match_result: 'match_result',
    reward_unlocked: 'reward_unlocked',
    quest_completed: 'quest_completed',
    level_up: 'level_up',
    clip_milestone: 'clip_milestone',
    streak_milestone: 'streak_milestone',
    streak_warning: 'streak_warning',
    friend_activity: 'friend_activity',
    system_message: 'system_message'
} as const;
export type NotificationResponseTypeEnum = typeof NotificationResponseTypeEnum[keyof typeof NotificationResponseTypeEnum];

/**
 * @export
 */
export const NotificationResponsePriorityEnum = {
    urgent: 'urgent',
    high: 'high',
    medium: 'medium',
    low: 'low'
} as const;
export type NotificationResponsePriorityEnum = typeof NotificationResponsePriorityEnum[keyof typeof NotificationResponsePriorityEnum];

/**
 * @export
 */
export const NotificationResponseActionTypeEnum = {
    link: 'link',
    accept_decline: 'accept_decline',
    dismiss: 'dismiss',
    custom: 'custom'
} as const;
export type NotificationResponseActionTypeEnum = typeof NotificationResponseActionTypeEnum[keyof typeof NotificationResponseActionTypeEnum];

/**
 * @export
 */
export const NotificationResponseSourceTypeEnum = {
    competition: 'competition',
    friend: 'friend',
    reward: 'reward',
    quest: 'quest',
    clip: 'clip',
    streak: 'streak',
    system: 'system'
} as const;
export type NotificationResponseSourceTypeEnum = typeof NotificationResponseSourceTypeEnum[keyof typeof NotificationResponseSourceTypeEnum];


/**
 * Check if a given object implements the NotificationResponse interface.
 */
export function instanceOfNotificationResponse(value: object): value is NotificationResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('priority' in value) || value['priority'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('body' in value) || value['body'] === undefined) return false;
    if (!('actionType' in value) || value['actionType'] === undefined) return false;
    if (!('read' in value) || value['read'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function NotificationResponseFromJSON(json: any): NotificationResponse {
    return NotificationResponseFromJSONTyped(json, false);
}

export function NotificationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': json['type'],
        'priority': json['priority'],
        'title': json['title'],
        'body': json['body'],
        'icon': json['icon'] == null ? undefined : json['icon'],
        'actionType': json['actionType'],
        'actionUrl': json['actionUrl'] == null ? undefined : json['actionUrl'],
        'actionData': json['actionData'] == null ? undefined : json['actionData'],
        'read': json['read'],
        'readAt': json['readAt'] == null ? undefined : (new Date(json['readAt'])),
        'sourceType': json['sourceType'] == null ? undefined : json['sourceType'],
        'sourceId': json['sourceId'] == null ? undefined : json['sourceId'],
        'createdAt': (new Date(json['createdAt'])),
    };
}

export function NotificationResponseToJSON(json: any): NotificationResponse {
    return NotificationResponseToJSONTyped(json, false);
}

export function NotificationResponseToJSONTyped(value?: NotificationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': value['type'],
        'priority': value['priority'],
        'title': value['title'],
        'body': value['body'],
        'icon': value['icon'],
        'actionType': value['actionType'],
        'actionUrl': value['actionUrl'],
        'actionData': value['actionData'],
        'read': value['read'],
        'readAt': value['readAt'] == null ? undefined : ((value['readAt']).toISOString()),
        'sourceType': value['sourceType'],
        'sourceId': value['sourceId'],
        'createdAt': ((value['createdAt']).toISOString()),
    };
}

